<span>
  <ng-content></ng-content>
</span>

<hf-named-icon *ngIf="icon" [icon]="icon"></hf-named-icon>

<hfc-spinner *ngIf="isLoading" size="link"></hfc-spinner>
